import { useState } from 'react'
import { ActionIcon, Checkbox, Collapse, Group, Stack, Text } from '@mantine/core'
import { ChevronDown, ChevronUp } from 'lucide-react'
import type { TodoProps } from '@/types'

type TodoListWidgetProps = {
  todos: TodoProps[]
}

export default function TodoListWidget({ todos }: TodoListWidgetProps) {
  const [expanded, setExpanded] = useState(true)

  const doneCount = todos.filter((t) => t.state === 'done').length
  const totalCount = todos.length

  return (
    <div
      style={{
        flexShrink: 0,
        backgroundColor: 'var(--mantine-color-gray-0)',
        borderBottom: '1px solid var(--mantine-color-gray-3)',
      }}
    >
      <Group
        justify="space-between"
        px="md"
        py="xs"
        style={{ cursor: 'pointer' }}
        onClick={() => setExpanded((v) => !v)}
      >
        <Text fw={600} size="sm">Todos</Text>
        <Group gap="xs">
          <Text size="sm" c="dimmed">{doneCount}/{totalCount}</Text>
          <ActionIcon variant="subtle" size="sm">
            {expanded ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
          </ActionIcon>
        </Group>
      </Group>

      <Collapse in={expanded}>
        <Stack gap={0} px="md" pb="xs">
          {todos.map((todo) => (
            <Group key={todo.id} gap="sm" py={4}>
              <Checkbox
                checked={todo.state === 'done'}
                readOnly
                size="sm"
                styles={{ input: { cursor: 'default' } }}
              />
              <Text
                size="sm"
                td={todo.state === 'done' ? 'line-through' : undefined}
                c={todo.state === 'done' ? 'dimmed' : undefined}
              >
                {todo.title}
              </Text>
            </Group>
          ))}
        </Stack>
      </Collapse>
    </div>
  )
}
